import { createSvgIcon } from '@mui/material';

export const StandingOrderIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="m9 21-1.425-1.4 1.6-1.6H9c-1.95 0-3.60417-.6792-4.9625-2.0375C2.67917 14.6042 2 12.95 2 11c0-1.95.67917-3.60417 2.0375-4.9625C5.39583 4.67917 7.05 4 9 4h6c1.95 0 3.6042.67917 4.9625 2.0375C21.3208 7.39583 22 9.05 22 11c0 1.95-.6792 3.6042-2.0375 4.9625C18.6042 17.3208 16.95 18 15 18v-2c1.3833 0 2.5625-.4875 3.5375-1.4625C19.5125 13.5625 20 12.3833 20 11c0-1.38333-.4875-2.5625-1.4625-3.5375C17.5625 6.4875 16.3833 6 15 6H9c-1.38333 0-2.5625.4875-3.5375 1.4625C4.4875 8.4375 4 9.61667 4 11c0 1.3833.4875 2.5708 1.4625 3.5625C6.4375 15.5542 7.61667 16.1 9 16.2h.4l-1.8-1.8L9 13l4 4-4 4Z"
    />
  </svg>,
  'StandingOrderIcon',
);
